$(document).ready(function() {
    var variant_illustrations_element = document.querySelector('#_common_variant_illustrations');
    var variant_illustrations = [];
    if(variant_illustrations_element)
        variant_illustrations = JSON.parse(variant_illustrations_element.textContent) || [];


    $('.bp-letter-illustration-selector').on('change', function(){
        let selected_letter = $(this).val();
        let variant = variant_illustrations[selected_letter]
        $('.bp-illustration-img').attr("src", variant.image)
    });

    $('#bp-letter-heading').on('input change', function(){
        let heading = $(this).val();

        $(this).val(heading.toUpperCase());
        $('.bp-poster-headline .bp-letter-heading').text(heading.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('#bp-letter-subheading').on('input change', function(){
        let subheading = $(this).val();

        $(this).val(subheading.toUpperCase());
        $('.bp-poster-subheading .bp-letter-subheading').text(subheading.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-subheading');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

});